// extracted by mini-css-extract-plugin
var _1 = "Aexfj";
var _2 = "PNSgw";
var _3 = "ZFQYn";
var _4 = "VMgZr";
var _5 = "bxf5q";
var _6 = "gKmKg";
export { _1 as "base", _2 as "textarea", _3 as "theme-dark", _4 as "theme-light", _5 as "variant-fill", _6 as "variant-outline" }
